/*
  KP: "Add accessories" panel on product pages. Replaces the add-on widget of the
  Selleasy (LB Upsell) app.

  The panel sits under the buy buttons. It is one card that is swiped sideways (or moved
  with the dots under it), one accessory at a time. Each accessory shows its photo, name,
  price, a short line of text, a dropdown when it comes in more than one kind, and an
  "+ Add" button that puts it in the cart straight away.

  Accessories follow the choices made on the product:
    - follow: 'Model'  the accessory's dropdown is set to the model chosen on the product,
                       and again whenever that model is changed. The shopper can still
                       pick another one from the dropdown. If the accessory does not come
                       in the product's model, it is left out.
    - when: {...}      the accessory is only offered for the listed choices (for example
                       the MagSafe ring only with a Tough Case).
    - text: '...'      the short grey line under the name (optional).
    - name: '...'      a shorter name to show instead of the product's own (optional).

  Which products get which accessories is set in RULES below. The first rule that matches
  the product is used. Accessory details (name, photo, price, variants) are read from the
  store when the page opens, so price or photo changes need no edit here.
*/
(function () {
  var API = '/api/2025-07/graphql.json';
  var MONEY_TOKEN = /\{\{\s*(\w+)\s*\}\}/;
  var ADD_LABEL = '+ Add';
  var ADDED_LABEL = '✓ Added';
  var FAILED_LABEL = 'Try again';

  var RULES = [
    {
      // Phone cases: products with a Model and a Case Type option.
      options: ['Model', 'Case Type'],
      title: 'Add accessories',
      note: '',
      items: [
        { handle: 'screen-protector-tempered-glass', follow: 'Model', text: 'Scratch and shatter-resistant tempered glass.' },
        { handle: 'phone-strap', text: 'Keeps your phone close, on your wrist or crossbody.' },
        { handle: 'magnetic-safe-ring', when: { option: 'Case Type', values: ['Tough Case'] }, text: 'Upgrade your Tough Case to work with MagSafe accessories.' }
      ]
    },
    {
      // Power banks: products that offer "Power Bank & Shell".
      value: 'Power Bank & Shell',
      title: 'Add accessories',
      note: '',
      items: [{ handle: 'magnetic-safe-ring', text: 'Don’t have a MagSafe phone case? Add this MagSafe attachment to upgrade your case.' }]
    }
  ];

  var QUERY_FIELDS = ' { title featuredImage { url(transform: { maxWidth: 240 }) } variants(first: 250) { nodes { id title availableForSale price { amount } compareAtPrice { amount } image { url(transform: { maxWidth: 240 }) } selectedOptions { name value } } } }';
  var loaded = {};

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function withSeparators(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  function money(amount) {
    var format = window.theme && window.theme.moneyFormat;
    var value = parseFloat(amount);

    if (!format || isNaN(value) || !MONEY_TOKEN.test(format)) return '';

    return format.replace(MONEY_TOKEN, function (match, type) {
      switch (type) {
        case 'amount_no_decimals':
          return withSeparators(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withSeparators(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withSeparators(value, 0, '.', ',');
        default:
          return withSeparators(value, 2, ',', '.');
      }
    });
  }

  // The choices made on the product, read from the theme's own selects: { name: { value, values } }.
  function choicesOf(wrapper) {
    var map = {};

    each(wrapper.querySelectorAll('select[name^="options["]'), function (select) {
      var match = select.name.match(/^options\[(.+)\]$/);
      if (!match) return;

      map[match[1]] = {
        value: select.value,
        values: Array.prototype.map.call(select.options, function (option) {
          return option.value;
        })
      };
    });

    return map;
  }

  function ruleFor(choices) {
    for (var i = 0; i < RULES.length; i++) {
      var rule = RULES[i];
      var ok = true;

      (rule.options || []).forEach(function (name) {
        if (!choices[name]) ok = false;
      });

      if (ok && rule.value) {
        ok = Object.keys(choices).some(function (name) {
          return choices[name].values.indexOf(rule.value) > -1;
        });
      }

      if (ok) return rule;
    }

    return null;
  }

  function load(handles) {
    var wanted = handles.filter(function (handle) {
      return loaded[handle] === undefined;
    });

    if (!wanted.length) return Promise.resolve();

    var query = 'query ($c: CountryCode) @inContext(country: $c) { ' + wanted.map(function (handle, n) {
      return 'p' + n + ': product(handle: ' + JSON.stringify(handle) + ')' + QUERY_FIELDS;
    }).join(' ') + ' }';

    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: { c: (window.Shopify && window.Shopify.country) || null } })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        wanted.forEach(function (handle, n) {
          var product = json && json.data ? json.data['p' + n] : null;
          loaded[handle] = product || null;
        });
      })
      .catch(function () {});
  }

  function variantsOf(handle) {
    var product = loaded[handle];
    var list = product && product.variants ? product.variants.nodes : [];

    return list.filter(function (variant) {
      return variant.availableForSale;
    });
  }

  function numberOf(variant) {
    return variant.id.split('/').pop();
  }

  function buildRow(item) {
    var product = loaded[item.handle];
    var variants = variantsOf(item.handle);
    if (!product || !variants.length) return null;

    var name = item.name || product.title;
    var row = el('div', 'kp-addons__item');
    row.kpItem = item;

    var image = el('img', 'kp-addons__image');
    image.alt = '';
    image.loading = 'lazy';
    image.width = 84;
    image.height = 84;
    row.appendChild(image);

    var body = el('div', 'kp-addons__body');

    var head = el('div', 'kp-addons__head');
    head.appendChild(el('div', 'kp-addons__name', name));
    head.appendChild(el('div', 'kp-addons__price'));
    body.appendChild(head);

    if (item.text) body.appendChild(el('div', 'kp-addons__text', item.text));

    var actions = el('div', 'kp-addons__actions');

    var select = el('select', 'kp-addons__select');
    select.setAttribute('data-kp-addon-variant', '');
    select.setAttribute('aria-label', name);

    variants.forEach(function (variant) {
      var option = el('option', '', variant.title);
      option.value = numberOf(variant);
      select.appendChild(option);
    });

    if (variants.length < 2) select.hidden = true;
    actions.appendChild(select);

    var button = el('button', 'kp-addons__add', ADD_LABEL);
    button.type = 'button';
    button.setAttribute('data-kp-addon-add', '');
    button.setAttribute('aria-label', 'Add ' + name + ' to cart');
    actions.appendChild(button);

    body.appendChild(actions);
    row.appendChild(body);

    return row;
  }

  // Show the price and photo of the variant chosen in a row.
  function paintRow(row) {
    var item = row.kpItem;
    var product = loaded[item.handle];
    var select = row.querySelector('[data-kp-addon-variant]');
    var variant = variantsOf(item.handle).filter(function (v) {
      return numberOf(v) === select.value;
    })[0];
    if (!variant) return;

    var price = row.querySelector('.kp-addons__price');
    var image = row.querySelector('.kp-addons__image');
    var onSale = variant.compareAtPrice && parseFloat(variant.compareAtPrice.amount) > parseFloat(variant.price.amount);

    price.innerHTML = (onSale ? '<s>' + money(variant.compareAtPrice.amount) + '</s> ' : '') + money(variant.price.amount);

    var src = (variant.image && variant.image.url) || (product.featuredImage && product.featuredImage.url) || '';
    if (src && image.getAttribute('src') !== src) image.setAttribute('src', src);
  }

  // ---- Swiping: the dots under the card ----

  function visibleRows(panel) {
    return Array.prototype.filter.call(panel.querySelectorAll('.kp-addons__item'), function (row) {
      return !row.hidden;
    });
  }

  function markDot(panel) {
    var track = panel.querySelector('[data-kp-addons-track]');
    var dots = panel.querySelectorAll('[data-kp-addons-dot]');
    if (!track || !dots.length) return;

    var index = Math.round(track.scrollLeft / (track.clientWidth || 1));
    index = Math.max(0, Math.min(index, dots.length - 1));

    each(dots, function (dot, i) {
      dot.classList.toggle('is-active', i === index);
      if (i === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function drawDots(panel) {
    var holder = panel.querySelector('[data-kp-addons-dots]');
    var count = visibleRows(panel).length;
    if (!holder) return;

    if (holder.children.length !== count) {
      holder.innerHTML = '';

      for (var i = 0; i < count; i++) {
        var dot = el('button', 'kp-addons__dot');
        dot.type = 'button';
        dot.setAttribute('data-kp-addons-dot', i);
        dot.setAttribute('aria-label', 'Accessory ' + (i + 1) + ' of ' + count);
        holder.appendChild(dot);
      }
    }

    holder.hidden = count < 2;
    markDot(panel);
  }

  function goTo(panel, index) {
    var track = panel.querySelector('[data-kp-addons-track]');
    if (!track) return;

    try {
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    } catch (e) {
      track.scrollLeft = index * track.clientWidth;
    }
  }

  // ---- Placing and updating ----

  // Under the buy buttons (and the "Tax included" line when there is one). The theme can
  // re-draw that part of the page, so this is checked again on every update.
  function place(wrapper, panel) {
    var product = wrapper.closest('.product');
    var form = product ? product.querySelector('form[data-product-form]:not(.visually-hidden)') || product.querySelector('form[data-product-form]') : null;
    var anchor = form || wrapper;
    var next = form ? form.nextElementSibling : null;

    // The "Add a 2nd case, half price" line (assets/kp-bundles.js) sits straight under Add to
    // Cart; this panel goes after it, so the two never push each other about when the
    // variant changes (16 Oct 2026, Sana: the line jumped up and down).
    if (next && next.matches && next.matches('.kp-bundles-nudge-box')) {
      anchor = next;
      next = next.nextElementSibling;
    }

    if (next && next.matches && next.matches('.product__policies')) anchor = next;

    if (panel.parentNode === anchor.parentNode && panel.previousElementSibling === anchor) return;
    anchor.parentNode.insertBefore(panel, anchor.nextSibling);
  }

  // Apply the product's current choices to every row: follow the model, hide what does not fit.
  function sync(wrapper, panel) {
    var choices = choicesOf(wrapper);
    var shown = 0;

    place(wrapper, panel);

    each(panel.querySelectorAll('.kp-addons__item'), function (row) {
      var item = row.kpItem;
      var select = row.querySelector('[data-kp-addon-variant]');
      var fits = true;

      if (item.when) {
        var chosen = choices[item.when.option];
        fits = !!chosen && item.when.values.indexOf(chosen.value) > -1;
      }

      if (fits && item.follow) {
        var wanted = choices[item.follow] ? choices[item.follow].value : '';
        var match = variantsOf(item.handle).filter(function (variant) {
          return variant.selectedOptions.some(function (option) {
            return option.name === item.follow && option.value === wanted;
          });
        })[0];

        if (!match) {
          fits = false;
        } else if (row.kpFollowed !== wanted) {
          // Only when the product's model has changed, so a choice the shopper made in the
          // accessory's own dropdown is not undone by other updates.
          select.value = numberOf(match);
          row.kpFollowed = wanted;
        }
      }

      row.hidden = !fits;

      if (fits) {
        shown++;
        paintRow(row);
      }
    });

    panel.hidden = shown === 0;
    drawDots(panel);
  }

  // ---- Adding to the cart ----

  // Tell the rest of the page the cart has changed: the header count (assets/kp-cart-sync.js)
  // and the Rebuy cart, so the accessory is there when the cart is next opened.
  function announce() {
    try {
      document.dispatchEvent(new CustomEvent('kp:cart.change'));
    } catch (e) {}

    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart();
    } catch (e) {}
  }

  function add(row, button) {
    var select = row.querySelector('[data-kp-addon-variant]');
    if (button.disabled || !select || !select.value) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    button.disabled = true;

    var done = function (ok) {
      button.textContent = ok ? ADDED_LABEL : FAILED_LABEL;
      button.classList.toggle('is-added', ok);
      if (ok) announce();

      window.setTimeout(function () {
        button.disabled = false;
        button.classList.remove('is-added');
        button.textContent = ADD_LABEL;
      }, ok ? 1800 : 1500);
    };

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(select.value, 10), quantity: 1 }] })
    }).then(function (response) {
      done(response.ok);
    }, function () {
      done(false);
    });
  }

  // ---- Start ----

  function start(wrapper) {
    if (wrapper.kpAddons) return;

    var rule = ruleFor(choicesOf(wrapper));
    if (!rule) return;
    wrapper.kpAddons = true;

    load(rule.items.map(function (item) {
      return item.handle;
    })).then(function () {
      var panel = el('div', 'kp-addons');
      panel.hidden = true;
      panel.appendChild(el('div', 'kp-addons__title', rule.title));
      if (rule.note) panel.appendChild(el('p', 'kp-addons__note', rule.note));

      var card = el('div', 'kp-addons__card');
      var track = el('div', 'kp-addons__track');
      track.setAttribute('data-kp-addons-track', '');

      var rows = 0;
      rule.items.forEach(function (item) {
        var row = buildRow(item);
        if (!row) return;
        track.appendChild(row);
        rows++;
      });

      if (!rows) return;

      var dots = el('div', 'kp-addons__dots');
      dots.setAttribute('data-kp-addons-dots', '');

      card.appendChild(track);
      card.appendChild(dots);
      panel.appendChild(card);

      place(wrapper, panel);
      document.documentElement.classList.add('kp-addons-on');

      panel.addEventListener('change', function (event) {
        var row = event.target.closest ? event.target.closest('.kp-addons__item') : null;
        if (row && event.target.matches('[data-kp-addon-variant]')) paintRow(row);
      });

      panel.addEventListener('click', function (event) {
        if (!event.target.closest) return;

        var dot = event.target.closest('[data-kp-addons-dot]');
        if (dot) {
          goTo(panel, parseInt(dot.getAttribute('data-kp-addons-dot'), 10));
          return;
        }

        var button = event.target.closest('[data-kp-addon-add]');
        if (button) add(button.closest('.kp-addons__item'), button);
      });

      var frame = null;
      track.addEventListener('scroll', function () {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = null;
          markDot(panel);
        });
      }, { passive: true });

      var timer = null;
      var again = function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          sync(wrapper, panel);
        }, 40);
      };

      // The theme re-draws the picker after every change, and our picker sets the selects.
      wrapper.addEventListener('change', again);
      if (window.MutationObserver) new MutationObserver(again).observe(wrapper, { childList: true, subtree: true });

      sync(wrapper, panel);
    });
  }

  function initAll() {
    each(document.querySelectorAll('.product__variants-wrapper'), start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
